import React, { useCallback, useEffect, useState } from "react";
import TooltipClicable from "~/shared/TooltipClicable";
import Request from "~/services/request";
import { toast } from "react-toastify";

type NotificationProps = {
    requestId: number;
    destination: string;
};

const Notification = ({ requestId, destination }: NotificationProps) => {
    const [lastMessage, setLastMessage] = useState<string>();
    const [hasNewMessage, setHasNewMessage] = useState(false);

    const getMessages = useCallback(async (requestId) => {
        return Request.getMessages(requestId)
            .then((res) => {
                const hasMsg = res.find((msg) => !msg.read && msg.sender === destination);
                setHasNewMessage(hasMsg ? true : false);
                setLastMessage(hasMsg?.message);
            })
            .catch((err) => {
                toast.error(
                    `Não foi possível recuperar as mensagens da solicitação: ${err?.response?.data?.msg || err.message}`
                );
            });
    }, []);

    useEffect(() => {
        getMessages(requestId);
    }, [getMessages, requestId]);

    return (
        <TooltipClicable
            message={lastMessage}
            hasNotification={hasNewMessage}
            isActionLink
            link={`/requests/${requestId}`}
        />
    );
};

export default Notification;
